import axios, { AxiosInstance } from "axios";
import * as sanitize from "sanitize-html";
import { Download } from "./components/download";
import { Help } from "./components/help";
import { Modal } from "./components/modal";
import { Setting } from "./components/setting";
import { RichTextService } from "./services/rich-text-service";
import { $, $$ } from "./utils/dom";
import { scrollSync } from "./utils/scroll-sync";

interface IModalFunction {
  [key: string]: (param?: any) => Promise<any>;
}

export class AppComponent {
  // instance for singleton
  private static singleton: AppComponent;
  // components
  private download: Download;
  private help: Help;
  private setting: Setting;
  private modal: Modal;
  // services
  private richTextService: RichTextService;

  // input element
  private $input: HTMLTextAreaElement;
  // output element
  private $output: HTMLDivElement;
  // http service
  private $http: AxiosInstance;

  /**
   * Creates an instance of AppComponent.
   *
   * @memberof AppComponent
   */
  constructor() {
    this.$input = $("#js__input") as HTMLTextAreaElement;
    this.$output = $("#js__output") as HTMLDivElement;
    this.$http = axios.create({
      baseURL: "https://www.nikaple.com/api",
      method: "GET",
      timeout: 30000
    });
    this.richTextService = RichTextService.instance;
    this.modal = Modal.instance;
    this.help = Help.instance;
    this.setting = Setting.instance;
    this.download = Download.instance;
  }

  public init() {
    this.help.init();
    this.modal.init();
    this.setting.init();
    this.download.init();
    this.attachEvents();
  }

  /**
   * Handles data from other components
   *
   * @private
   *
   * @memberof AppComponent
   */
  public update() {
    const reference = sanitize(this.$input.value);
    const richText = this.richTextService.generate(reference);
    this.$output.innerHTML = richText;
  }

  /**
   * attach all events
   *
   * @private
   *
   * @memberof AppComponent
   */
  private attachEvents() {
    // 左右同步滚动
    scrollSync(this.$input, $("#js__output_container"));
    this.$input.addEventListener("input", this.update.bind(this));
    window.addEventListener("settingUpdate", this.update.bind(this));
  }

  /**
   * Creates an unique singleton of AppComponent
   *
   * @readonly
   * @static
   * @type {AppComponent}
   * @memberof AppComponent
   */
  public static get instance(): AppComponent {
    if (!AppComponent.singleton) {
      AppComponent.singleton = new AppComponent();
    }
    return AppComponent.singleton;
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/app-component.ts